import type { FaireProductEntity } from "../../entity_types/product";

export const p_32tk8etdjy: FaireProductEntity = {
  token: "p_32tk8etdjy",
  type: "product",
  name: "Self-Care Gift Set with Ceramic Heart Dish & Bath Essentials",
  brandName: "J&F Gift Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/5e03f192803c7bae07f9f67f752f7737636ee640efbf317565049218bb140a5a.png",
  priceDollars: 16,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/74358a2377253ba044eadc70f27b51e5e99778a024843ee84b46bdda9daf5be6.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
